"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
// //
// // assets
// //
const securityCopy_1 = require("../../../../copy/securityCopy");
const queryDefinitions_1 = require("../../../../queryDefinitions");
// //
// // components
// //
const PasswordInput_1 = __importDefault(require("../../../general/inputs/PasswordInput"));
const FormValidation_1 = require("../../../general/utility/FormValidation");
// //
// // styles
// //
const StyledInputContainer_1 = require("../StyledInputContainer");
const StyledSubHeader_1 = require("../StyledSubHeader");
const StyledParagraph_1 = require("../StyledParagraph");
const StyledInvalidFeedback_1 = require("../../StyledInvalidFeedback");
const react_bootstrap_1 = require("react-bootstrap");
const MalomoButton_1 = require("../../MalomoButton");
const Security = () => {
    const [currentPassword, setCurrentPassword] = (0, react_1.useState)('');
    const [newPassword, setNewPassword] = (0, react_1.useState)('');
    const [passwordConfirmation, setPasswordConfirmation] = (0, react_1.useState)('');
    const [currentPasswordError, setCurrentPasswordError] = (0, react_1.useState)('');
    const [newPasswordError, setNewPasswordError] = (0, react_1.useState)('');
    const [passwordConfirmationError, setPasswordConfirmationError] = (0, react_1.useState)('');
    const [buttonStatus, setButtonStatus] = (0, react_1.useState)('');
    function handleBlur(event) {
        const error = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (error) {
            if (event.target.id === 'currentPassword') {
                setCurrentPasswordError(error);
            }
            if (event.target.id === 'newPassword') {
                setNewPasswordError(error);
            }
            if (event.target.id === 'passwordConfirmation') {
                setPasswordConfirmationError(error);
            }
        }
        else {
            if (event.target.id === 'currentPassword') {
                setCurrentPasswordError('');
            }
            if (event.target.id === 'newPassword') {
                setNewPasswordError('');
            }
            if (event.target.id === 'passwordConfirmation') {
                setPasswordConfirmationError('');
            }
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'currentPassword') {
            setCurrentPassword(event.target.value);
        }
        if (event.target.id === 'newPassword') {
            setNewPassword(event.target.value);
        }
        if (event.target.id === 'passwordConfirmation') {
            setPasswordConfirmation(event.target.value);
        }
    }
    const [changeUserPassword, { data: passwordData, loading: passwordLoading, error: passwordError }] = (0, client_1.useMutation)(queryDefinitions_1.UPDATE_USER_PASSWORD);
    function handleUpdateUserPassword() {
        setButtonStatus('Loading...');
        changeUserPassword({
            variables: {
                input: {
                    currentPassword: currentPassword,
                    password: newPassword,
                    passwordConfirmation: passwordConfirmation
                }
            }
        });
    }
    (0, react_1.useEffect)(() => {
        if (passwordData) {
            setButtonStatus('Success!');
            setTimeout(() => {
                setButtonStatus('');
            }, 5000);
        }
        if (passwordError) {
            setButtonStatus('');
        }
    }, [passwordData, passwordError]);
    function displayApiError(error) {
        if (error.message === 'Failed to fetch') {
            return 'The server could not be reached, please try again later';
        }
        if (error.message === 'valid') {
            return 'Your current password was incorrect, please try again';
        }
        if (error.message === 'confirmation') {
            return 'The password confirmation does not match, please try again';
        }
        if (error.message === 'length') {
            return 'Your new password is too short, please try again';
        }
        if (error.message.includes('required')) {
            return 'All input is required, please try again';
        }
        return error.message;
    }
    return (react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, null, securityCopy_1.securityCopy.header1),
                react_1.default.createElement(StyledParagraph_1.StyledParagraph, null, securityCopy_1.securityCopy.paragraph1)),
            react_1.default.createElement(StyledInputContainer_1.StyledInputContainer, null,
                react_1.default.createElement(PasswordInput_1.default, { error: currentPasswordError, id: 'currentPassword', label: securityCopy_1.securityCopy.label1, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(PasswordInput_1.default, { error: newPasswordError, id: 'newPassword', label: securityCopy_1.securityCopy.label2, onBlur: handleBlur, onInputChange: handleInputChange, spacing: '15px' }),
                react_1.default.createElement(PasswordInput_1.default, { error: passwordConfirmationError, id: 'passwordConfirmation', label: securityCopy_1.securityCopy.label3, onBlur: handleBlur, onInputChange: handleInputChange, spacing: '15px' }),
                react_1.default.createElement(MalomoButton_1.MalomoButton, { className: passwordData ? 'password-success' : '', disabled: passwordLoading ? passwordLoading : false, id: 'password-button', onClick: handleUpdateUserPassword }, buttonStatus ? buttonStatus : securityCopy_1.securityCopy.button1),
                passwordError ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'api-error invalid-feedback' }, displayApiError(passwordError))) : null),
            react_1.default.createElement("div", null))));
};
exports.default = Security;
